<template>
  <div>
    <div class="header">
      <div class="clock">{{clock}}</div>
      <div class="stop-name">{{panelConfig.panelHeader}}</div>
    </div>
    <DeparturesTable :panelConfig="panelConfig" :stopData="stopData"></DeparturesTable>
  </div>
</template>

<script>
import DeparturesTable from './DeparturesTable';

export default {
  components: {
    DeparturesTable
  },
  props: ['panelConfig', 'stopData', 'clock'],
};
</script>

<style lang="scss" scoped>
.header {
  padding: 1em .6em;
}
.clock {
  float: right;
}

@media only screen and (min-width: 600px) {
  .clock {
    font-size: 2.4em;
    margin-top: -.43em;
  }
}
</style>